export default [
	//商户列表
	{
		path: 'list',
		name: 'm_saas',
		props: route => route.params,
		component: () => import('@/pages/saas/saas_list')
	},
	//商户版本列表
	{
		path: 'version',
		name: 'm_version',
		props: route => route.params,
		component: () => import('@/pages/saas/version_list')
	},
	//账号风险管控列表
	{
		path: 'risk',
		name: 'm_risk',
		props: route => route.params,
		component: () => import('@/pages/saas/risk_list')
	},
	//商户电子货架管理
	{
		path: 'shelf',
		name: 'm_electronic_shelf',
		props: route => route.params,
		component: () => import('@/pages/saas/saas_electronic_shelf_list')
	},
	//商家入驻申请列表
	{
		path: 'apply',
		name: 'm_saas_apply',
		props: route => route.params,
		component: () => import('@/pages/saas/saas_apply_list')
	}
];
